import { IdentityClientSettings } from '@gsgroup/gsgroup-react-ui';
import { createUserManager } from 'redux-oidc';
import { AuthMethod } from '../common/enums';

const createCompanySpecificUserManager = (clientSettings: IdentityClientSettings) => {
  const userManagerConfig = {
    client_id: clientSettings.clientId,
    client_secret: clientSettings.clientSecret,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/oauth-callback`,
    response_type: 'code',
    scope: clientSettings.scope,
    authority: clientSettings.authority,
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent-renew`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: clientSettings.authMethod === AuthMethod.IDM,
    monitorSession: true,
    extraQueryParams: clientSettings.extraQueryParams
  };
  
  return createUserManager(userManagerConfig);
}

export default createCompanySpecificUserManager;
